import TimerRegistrationService from '@/shared/services/TimerRegistrationService';
import { useEffect, useState } from 'react';
import eventBus from 'pubsub-js';
export var useGetTimerRegistration = function () {
    var _a = useState(TimerRegistrationService.getRunningRegistration()), registration = _a[0], setRegistration = _a[1];
    useEffect(function () {
        var sub = eventBus.subscribe('timerRegistrationChanged', function () {
            setRegistration(TimerRegistrationService.getRunningRegistration());
        });
        return function () {
            eventBus.unsubscribe(sub);
        };
    }, []);
    return registration;
};
export var useGetRunningTaskId = function () {
    var registration = useGetTimerRegistration();
    return registration === null || registration === void 0 ? void 0 : registration.plannedTaskId;
};
